import { Scene } from "../../tools/Scene";
import { TitleScene } from "./TitleScene";
import { Button } from "../../ui/Button";
import { LocalizationManager } from "../../managers/LocalizationManager";
import { MuteButton } from "./MuteButton";
import { GameType } from "../../models/CBNGameModel";

export class EagleEyeExamTitle{

    glow:Phaser.GameObjects.Sprite|null = null;
    gizmo:Phaser.GameObjects.Sprite|null = null;
    superbook:Phaser.GameObjects.Sprite|null = null;
    eagleeye:Phaser.GameObjects.Sprite|null = null;
    exam:Phaser.GameObjects.Sprite|null = null;

    scene:Scene;
    group:Phaser.GameObjects.Group;

    constructor(scene:Scene){
        this.scene = scene;
        

        let image:Phaser.GameObjects.Image;
        let sprite:Phaser.GameObjects.Sprite;
        let button:Button;
        let position;
        let group = scene.add.group({});
        this.group = group;

        position = scene.scaleManager.getRelativePosition(0.5,0.5);

        this.glow = scene.add.sprite(position.x,position.y,'title_glow');

        this.gizmo = scene.add.sprite(position.x,position.y,'title_eee_gizmo');

        this.superbook = scene.add.sprite(position.x,position.y-400,'title_superbook');
        this.eagleeye = scene.add.sprite(position.x-50,position.y-150,'title_eee_eagleeye');
        this.exam = scene.add.sprite(position.x,position.y+100,'title_eee_exam');
        
        group.add(this.glow);
        group.add(this.gizmo);
        group.add(this.eagleeye);
        group.add(this.exam);
        group.add(this.superbook);

        Phaser.Actions.SetAlpha(this.group.getChildren(),0);
        let startingScale = scene.scaleManager.isOrientationLandscape() ? 1 : .7;
        let timeline = scene.tweens.createTimeline({});
        timeline.add({
            targets: this.group.getChildren(),
            scaleX: 0.01,
            scaleY: 0.01,
            //alpha: 1,
            duration: 1
        });
        timeline.add({
            targets: this.eagleeye,
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
        });
        timeline.add({
            targets: this.exam,
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
            delay: 0,
            offset: '-= 100'
        });

        timeline.play();
        timeline = scene.tweens.createTimeline({});
        
        timeline.add({
            targets: [this.gizmo,this.glow],
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
            delay: 200
        });
        timeline.add({
            targets: this.superbook,
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
        });
        
        scene.tweens.add({
            targets: this.glow,
            scaleX: 0.75,
            scaleY: 0.75,
            duration: 2000,
            ease: 'Power1',
            yoyo:true,
            loop: -1
        });

        timeline.play();
    }

    reorient(landscape:boolean){
        let position;
        if(landscape){

            Phaser.Actions.SetScale(this.group!.getChildren(),1,1);
            position = this.scene.scaleManager.getRelativePosition(0.5,0.5);
            
            this.glow!.setPosition(position.x,position.y);
            this.superbook!.setPosition(position.x,position.y-180);

            this.gizmo!.setPosition(position.x-280,position.y-50);

            this.eagleeye!.setPosition(position.x,position.y-70);
            this.exam!.setPosition(position.x,position.y+70);
        }else{
            Phaser.Actions.SetScale(this.group!.getChildren(),.7,.7);
            position = this.scene.scaleManager.getRelativePosition(0.5,0.4);
            
            this.glow!.setPosition(position.x,position.y);
            this.superbook!.setPosition(position.x,position.y-130);

            this.gizmo!.setPosition(position.x-200,position.y-40);

            this.eagleeye!.setPosition(position.x,position.y-50);
            this.exam!.setPosition(position.x,position.y+50);
        }
    }
}